import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { BaseUrlService } from './base-url.service';
import forEach from 'lodash/forEach';
import values from 'lodash/values';
import map from 'lodash/map';
import filter from 'lodash/filter';
import findIndex from 'lodash/findIndex';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { swalMini } from '../../../../shared/utils/utils';

@Component({
  selector: 'app-base-url',
  templateUrl: './base-url.component.html',
  styleUrls: ['./base-url.component.scss'],
  providers: [BaseUrlService],
})
export class BaseUrlComponent implements OnInit {
  public baseUrlForm: FormGroup;
  private urlPattern: RegExp =
    /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
  @ViewChildren('baseUrlInput') baseUrlInputs!: QueryList<ElementRef>;

  constructor(private baseUrlService: BaseUrlService, private formBuilder: FormBuilder) {}

  ngOnInit() {
    this.baseUrlForm = this.formBuilder.group({
      urls: new FormArray([]),
    });

    this.baseUrlService.getBaseUrls().subscribe((item) => {
      forEach(item, (val, key) => {
        val.id = key;
        val.status = null;
      });

      map(values(item), (listItem) => {
        this.getUrlsFormGroup().push(
          this.formBuilder.group({
            url: [listItem.url, [Validators.required, Validators.pattern(this.urlPattern)]],
            id: [listItem.id, [Validators.required]],
            status: [listItem.status],
          })
        );
      });
    });
  }

  getUrlsFormGroup() {
    return this.baseUrlForm.controls.urls as FormArray;
  }

  setFocus(i) {
    setTimeout(() => {
      this.baseUrlInputs.forEach((el) => {
        if (el.nativeElement.id === `input-${i}`) el.nativeElement.focus();
      });
    }, 200);
  }

  newBaseURL() {
    this.getUrlsFormGroup().push(
      this.formBuilder.group({
        url: ['', [Validators.required, Validators.pattern(this.urlPattern)]],
        id: [`new-${Date.now()}`, [Validators.required]],
        status: ['new'],
      })
    );
  }

  saveBaseUrl() {
    if (this.getUrlsFormGroup().valid) {
      map(filter(this.getUrlsFormGroup().value, { status: 'new' }), (item) => {
        this.baseUrlService.addBaseUrl(item.url).subscribe((res) => {
          const i = findIndex(this.getUrlsFormGroup().value, { id: item.id });
          this.getCurrUrl(i).item.setValue({ ...this.getCurrUrl(i).value, status: null });
        });
      });

      map(filter(this.getUrlsFormGroup().value, { status: 'edited' }), (item) => {
        this.baseUrlService.editBaseUrl(item.url, item.id).subscribe((res) => {
          const i = findIndex(this.getUrlsFormGroup().value, { id: item.id });
          this.getCurrUrl(i).item.setValue({ ...this.getCurrUrl(i).value, status: null });
        });
      });
    } else {
      swalMini({
        title: 'Validation failed, please check for errors!',
        type: 'error',
      });
    }
  }

  getCurrUrl(i) {
    return {
      item: this.getUrlsFormGroup().at(i) || null,
      value: this.getUrlsFormGroup().value[i] || null,
    };
  }

  editBaseUrl(i) {
    if (this.getCurrUrl(i).item && this.getCurrUrl(i).value) {
      this.getCurrUrl(i).item.setValue({ ...this.getCurrUrl(i).value, status: 'edit' });
      this.setFocus(i);
    }
  }

  removeBaseUrl(i, e) {
    e.preventDefault();
    const currItem = this.getUrlsFormGroup().value[i];
    if (currItem && currItem.status !== 'new') {
      this.baseUrlService.removeBaseUrl(currItem.id).subscribe(
        () => {
          this.removeFromList(i);
        },
        (data) => {
          if (data.error && data.error.message) {
            swalMini({
              title: data.error.message,
              type: 'error',
            });
          }
        }
      );
    } else {
      this.removeFromList(i);
    }
  }

  removeFromList(i) {
    this.getUrlsFormGroup().removeAt(i);
    swalMini({
      title: 'Base URL removed successfully!',
      type: 'success',
    });
  }

  onChange(i, event) {
    if (this.getCurrUrl(i).item && this.getCurrUrl(i).value) {
      this.getCurrUrl(i).item.setValue({
        ...this.getCurrUrl(i).value,
        url: event.target.value.trim(),
      });
    }
  }

  onBlur(i) {
    if (this.getCurrUrl(i).item && this.getCurrUrl(i).value && this.getCurrUrl(i).item.valid) {
      if (this.getCurrUrl(i).value.status !== 'new') {
        this.getCurrUrl(i).item.setValue({ ...this.getCurrUrl(i).value, status: 'edited' });
      }
    }
  }
}
